import {NgModule} from '@angular/core';

import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {AcAllocationBarComponent} from './ac-allocation-bar.component';
import {InfraPipesModule} from '../../pipes/infra.pipes.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        InfraPipesModule
    ],
    declarations: [
        AcAllocationBarComponent,
    ],
    entryComponents: [
        AcAllocationBarComponent,
    ],
    exports: [
        AcAllocationBarComponent,
    ]
})
export class AcAllocationBarModule {
}
